// extracted by mini-css-extract-plugin
export default {"control":"SegmentedControl_control__+Hb37","option":"SegmentedControl_option__n5ezi","selected":"SegmentedControl_selected__1axOs"};